import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ContactSheetFolders.css';

function convertDate(inputDate) {
  const year = inputDate.substring(0, 4);
  const month = inputDate.substring(4, 6);
  const day = inputDate.substring(6, 8);
  return `${day}-${month}-${year}`;
}

function capitalizeFirstLetter(inputString) {
  if (!inputString || typeof inputString !== 'string') return '';
  const lower = inputString.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function ContactSheetFolders({ folders }) {
  const [selectedFolder, setSelectedFolder] = useState(null);

  const handleFolderClick = (folderName) => {
    setSelectedFolder(folderName);
  };

  return (
    <div className='gallery-container'>
      <div className='folder-grid'>
        {folders.map((folder, index) => (
          <div
            className='foldergrid-thumbnail'
            key={index}
            style={{ textAlign: 'center', borderRadius: '8px', padding: '4px' }}
            onClick={() => handleFolderClick(folder.folderName)}
          >
            <Link to={`/gallery/${folder.folderName}`}>
              <img
                src={folder.thumbnail}
                alt={folder.folderName}
                style={{ width: '100%', height: 'auto', borderRadius: '5px' }}
              />
            </Link>
            <div className='thumb-headline'>
              <div className='thumb-headline-info'>
                <div>
                  {capitalizeFirstLetter(folder.city) + ','}
                  <span style={{ marginLeft: '5px' }}>{convertDate(folder.date)}</span>
                </div>
                <div style={{ textAlign: 'right', paddingRight: '10px' }}>
                  {folder.fileCount} foto
                </div>
              </div>
              <div className='thumb-headline-text'>{folder.headline}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactSheetFolders;
